import { initBootAudio } from '../components/audio/bootAudio';

let unlocked = false;
let bound = false;

const BOOT_AUDIO_SRC = '../components/audio/boot.mp3'; 

function unlock() {
    if (unlocked) return;
    unlocked = true;

    initBootAudio(BOOT_AUDIO_SRC);

    window.removeEventListener('touchstart', unlock);
    window.removeEventListener('mousedown', unlock);
}

export function attachAudioUnlock() {
    if (bound) return;
    bound = true;

    window.addEventListener('touchstart', unlock, { passive: true });
    window.addEventListener('mousedown', unlock);
}
